export default {
    //韩语
    DiagnosticReport:'진단 보고서',
    troubleCode:'장애 코드',
    time:'시간',
    // 语言
    lang:{
        cn:'중국어',
        de:'독일어',
        en:'영어',
        es:'스페인어',
        fr:'프랑스어',
        it:'이탈리아어',
        ja:'일본어',
        ko:'한국어',
        pt:'포르투갈어'
    },
    PositioningPrompt:'위치 기능을 켜서 현지 가격을 확인하세요',
    FaultCode:'고장 코드',
    AIDiagnosis:'AI 진단',
    AIWait:'AI 보고서 또는 자동 진단 대기',
    FailedFaultCode:'고장 코드 정보를 가져올 수 없습니다',
    AIError:'AI 분석 실패',
    more:'더 많은',
    StoredCodes:'코드 저장',
    PendingCodes:'처리할 코드',
    PermanentCodes:'영구 인코딩',
    Unknown:'알 수 없는',
    ManufacturerControl:'제조업체 통제'
}